<div class="header_clock">
    <p class="timer">{{now|date:'hh:mm:ss'}}</p>
    <p class="date">{{now|date:'dd-MM-yyyy'}}</p>
</div>